import { type FormEvent, useState } from "react";
import { useNavigate } from "react-router";
import { useAdminAuth } from "../../context/admin-auth";

export function AdminSignInPage() {
	const navigate = useNavigate();
	const { checkSession } = useAdminAuth();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	async function handleSubmit(e: FormEvent) {
		e.preventDefault();
		setError("");
		setLoading(true);
		try {
			const res = await fetch("/api/admin/auth/sign-in/email", {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
					Origin: window.location.origin,
				},
				body: JSON.stringify({ email, password }),
			});
			if (!res.ok) {
				const body = await res.json().catch(() => null);
				setError(
					(body as { message?: string } | null)?.message ??
						`Sign-in failed (${res.status})`,
				);
				return;
			}
			await checkSession();
			navigate("/admin");
		} catch {
			setError("Network error");
		} finally {
			setLoading(false);
		}
	}

	return (
		<>
			<h1 className="text-2xl font-bold text-gray-900 mb-4">Admin Sign In</h1>
			{error && <p className="text-red-600 text-sm mb-3">{error}</p>}
			<form onSubmit={handleSubmit} className="space-y-4">
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1">
						Email
						<input
							name="email"
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required
							className="mt-1 block w-full rounded border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
						/>
					</label>
				</div>
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1">
						Password
						<input
							name="password"
							type="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
							className="mt-1 block w-full rounded border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
						/>
					</label>
				</div>
				<button
					type="submit"
					disabled={loading}
					className="w-full rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
				>
					{loading ? "Signing in\u2026" : "Sign In"}
				</button>
			</form>
		</>
	);
}
